// @ vendors
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
const PropTypes = require('prop-types');
// @ hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
// @ components
import NotFoundView from 'routes/notFoundView/notFoundView';

import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

class FeatureToggingRouteTink extends Component {
    render() {
        const { component: WrappedComponent, componentTink: WrappedComponentTink, notAllowedProductKey, flagBasedFeatures, redirectPath = false } = this.props;
        const isTinkAggregator = flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

        if (flagBasedFeatures.get(notAllowedProductKey)) {
            return isTinkAggregator ? (
                <WrappedComponentTink {...this.props} />
            ) : (
                <WrappedComponent {...this.props} />
            );
        } else if (!flagBasedFeatures.get(notAllowedProductKey) && redirectPath) {
            return <Redirect to={redirectPath} />;
        } else {
            return <NotFoundView notFoundViewPrivate={true} />;
        }
    }
}

FeatureToggingRouteTink.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    component: PropTypes.elementType.isRequired,
    componentTink: PropTypes.elementType.isRequired,
    notAllowedProductKey: PropTypes.string.isRequired,
    redirectPath: PropTypes.bool
}

export default withFeatureToggling(FeatureToggingRouteTink);
